<template>
    <Modal2
        v-if="isModalShow"
        id="site-form"
        :title="editMode ? $t('message.updateSiteForm') : $t('message.newSiteForm')"
        :visible="visible"
        :show-footer="false"
        @cancel="closeModal"
    >
        <b-form class="d-flex flex-column justify-content-center" @submit.prevent="submit">
            <b-row>
                <b-col md="4">
                    <md-field
                        :class="{
                            'md-invalid': errors.first($t('message.rootUserName')) != null,
                        }"
                    >
                        <label>{{ $t("message.rootUserName") }}</label>
                        <md-input
                            v-model="config.rootUserName"
                            v-validate="'required'"
                            :name="$t('message.rootUserName')"
                        ></md-input>
                        <span class="md-error">{{ errors.first($t("message.rootUserName")) }}</span>
                    </md-field>
                </b-col>
                <b-col md="4">
                    <md-field
                        :class="{
                            'md-invalid': errors.first($t('message.rootUserEmail')) != null,
                        }"
                    >
                        <label>{{ $t("message.rootUserEmail") }}</label>
                        <md-input
                            v-model="config.rootUserEmail"
                            v-validate="'required'"
                            :name="$t('message.rootUserEmail')"
                        ></md-input>
                        <span class="md-error">{{ errors.first($t("message.rootUserEmail")) }}</span>
                    </md-field>
                </b-col>
                <b-col v-if="!editMode" md="4">
                    <md-field
                        :class="{
                            'md-invalid': errors.first($t('message.organizationName')) != null,
                        }"
                    >
                        <label>{{ $t("message.organizationName") }}</label>
                        <md-input
                            v-model="config.organizationName"
                            v-validate="'required'"
                            :name="$t('message.organizationName')"
                        ></md-input>
                        <span class="md-error">{{ errors.first($t("message.organizationName")) }}</span>
                    </md-field>
                </b-col>
                <b-col md="4">
                    <md-field
                        :class="{
                            'md-invalid': errors.first($t('message.siteAddress')) != null,
                        }"
                    >
                        <label>{{ $t("message.siteAddress") }}</label>
                        <md-input
                            v-model="site.siteAddress"
                            v-validate="'required'"
                            :name="$t('message.siteAddress')"
                        ></md-input>
                        <span class="md-error">{{ errors.first($t("message.siteAddress")) }}</span>
                    </md-field>
                </b-col>
                <b-col md="4">
                    <md-field
                        :class="{
                            'md-invalid': errors.first($t('message.siteAlias')) != null,
                        }"
                    >
                        <label>{{ $t("message.siteAlias") }}</label>
                        <md-input
                            v-model="site.alias"
                            v-validate="'required'"
                            :name="$t('message.siteAlias')"
                        ></md-input>
                        <span class="md-error">{{ errors.first($t("message.siteAlias")) }}</span>
                    </md-field>
                </b-col>
                <b-col md="4">
                    <md-field
                        :class="{
                            'md-invalid': errors.first($t('message.customerRepLimit')) != null,
                        }"
                    >
                        <label>{{ $t("message.customerRepLimit") }}</label>
                        <md-input
                            v-model="site.customerRepresentativeLimit"
                            v-validate="'required|integer|min:-1|max:100'"
                            :max="100"
                            :min="-1"
                            :name="$t('message.customerRepLimit')"
                            type="number"
                        ></md-input>
                        <span class="md-error">{{ errors.first($t("message.customerRepLimit")) }}</span>
                    </md-field>
                </b-col>
                <b-col md="4">
                    <md-field
                        :class="{
                            'md-invalid': errors.first($t('message.customerCssUrl')) != null,
                        }"
                    >
                        <label>{{ $t("message.customerCssUrl") }}</label>
                        <md-input
                            v-model="site.customerCssUrl"
                            v-validate="'url'"
                            :name="$t('message.customerCssUrl')"
                        ></md-input>
                        <span class="md-error">{{ errors.first($t("message.customerCssUrl")) }}</span>
                    </md-field>
                </b-col>
                <b-col md="4">
                    <md-field
                        :class="{
                            'md-invalid': errors.first($t('message.customerLogoUrl')) != null,
                        }"
                    >
                        <label>{{ $t("message.customerLogoUrl") }}</label>
                        <md-input
                            v-model="site.customerLogoUrl"
                            v-validate="'url'"
                            :name="$t('message.customerLogoUrl')"
                        ></md-input>
                        <span class="md-error">{{ errors.first($t("message.customerLogoUrl")) }}</span>
                    </md-field>
                </b-col>
                <b-col md="4">
                    <md-field
                        :class="{
                            'md-invalid': errors.first($t('message.panelCustomCssUrl')) != null,
                        }"
                    >
                        <label>{{ $t("message.panelCustomCssUrl") }}</label>
                        <md-input
                            v-model="site.panelCustomCssUrl"
                            v-validate="'url'"
                            :name="$t('message.panelCustomCssUrl')"
                        ></md-input>
                        <span class="md-error">{{ errors.first($t("message.panelCustomCssUrl")) }}</span>
                    </md-field>
                </b-col>
                <b-col md="4">
                    <md-field
                        :class="{
                            'md-invalid': errors.first($t('message.panelLogoUrl')) != null,
                        }"
                    >
                        <label>{{ $t("message.panelLogoUrl") }}</label>
                        <md-input
                            v-model="site.panelLogoUrl"
                            v-validate="'url'"
                            :name="$t('message.panelLogoUrl')"
                        ></md-input>
                        <span class="md-error">{{ errors.first($t("message.panelLogoUrl")) }}</span>
                    </md-field>
                </b-col>

                <b-col md="4">
                    <md-field
                        :class="{
                            'md-invalid': errors.first($t('message.customerClientAddress')) != null,
                        }"
                    >
                        <label>{{ $t("message.customerClientAddress") }}</label>
                        <md-input
                            v-model="site.customerClientAddress"
                            v-validate="'required'"
                            :name="$t('message.customerClientAddress')"
                        ></md-input>
                        <span class="md-error">{{ errors.first($t("message.customerClientAddress")) }}</span>
                    </md-field>
                </b-col>
                <b-col md="4">
                    <md-field
                        :class="{
                            'md-invalid': errors.first($t('message.clientAddress')) != null,
                        }"
                    >
                        <label>{{ $t("message.clientAddress") }}</label>
                        <md-input
                            v-model="site.clientAddress"
                            v-validate="'required'"
                            :name="$t('message.clientAddress')"
                        ></md-input>
                        <span class="md-error">{{ errors.first($t("message.clientAddress")) }}</span>
                    </md-field>
                </b-col>
                <b-col md="4">
                    <md-field
                        :class="{
                            'md-invalid': errors.first($t('message.basePriceValue')) != null,
                        }"
                    >
                        <label>{{ $t("message.basePriceValue") }}</label>
                        <md-input
                            v-model="site.basePrice.value"
                            v-validate="'required|min:0|decimal'"
                            :min="0"
                            :name="$t('message.basePriceValue')"
                            step="0.01"
                            type="number"
                        ></md-input>
                        <span class="md-error">{{ errors.first($t("message.basePriceValue")) }}</span>
                    </md-field>
                </b-col>

                <b-col md="4">
                    <md-field
                        :class="{
                            'md-invalid': errors.first($t('message.whatsappBasePriceValue')) != null,
                        }"
                    >
                        <label>{{ $t("message.whatsappBasePriceValue") }}</label>
                        <div v-if="site.whatsappBasePrice">
                            <md-input
                                v-model="site.whatsappBasePrice.value"
                                v-validate="!!site.whatsappBasePrice.value ? 'required|min:0|decimal' : null"
                                :min="0"
                                :name="$t('message.whatsappBasePriceValue')"
                                step="0.01"
                                type="number"
                            ></md-input>
                            <span class="md-error">{{ errors.first($t("message.whatsappBasePriceValue")) }}</span>
                        </div>
                        <div v-else>N/A</div>
                    </md-field>
                </b-col>
                <b-col md="4">
                    <md-field
                        :class="{
                            'md-invalid': errors.first($t('message.whatsappPlusBasePriceValue')) != null,
                        }"
                    >
                        <label>{{ $t("message.whatsappPlusBasePriceValue") }}</label>
                        <div v-if="site.whatsappPlusBasePrice">
                            <md-input
                                v-model="site.whatsappPlusBasePrice.value"
                                v-validate="!!site.whatsappPlusBasePrice.value ? 'required|min:0|decimal' : null"
                                :min="0"
                                :name="$t('message.whatsappPlusBasePriceValue')"
                                step="0.01"
                                type="number"
                            ></md-input>
                            <span class="md-error">{{ errors.first($t("message.whatsappPlusBasePriceValue")) }}</span>
                        </div>
                        <div v-else>N/A</div>
                    </md-field>
                </b-col>

                <b-col md="4">
                    <md-field
                        :class="{
                            'md-invalid': errors.first($t('message.instagramBasePriceValue')) != null,
                        }"
                    >
                        <label>{{ $t("message.instagramBasePriceValue") }}</label>
                        <div v-if="site.instagramBasePrice">
                            <md-input
                                v-model="site.instagramBasePrice.value"
                                v-validate="!!site.instagramBasePrice.value ? 'required|min:0|decimal' : null"
                                :min="0"
                                :name="$t('message.instagramBasePriceValue')"
                                step="0.01"
                                type="number"
                            ></md-input>
                            <span class="md-error">{{ errors.first($t("message.instagramBasePriceValue")) }}</span>
                        </div>
                        <div v-else>N/A</div>
                    </md-field>
                </b-col>
                <b-col md="4">
                    <md-field
                        :class="{
                            'md-invalid': errors.first($t('message.instagramPlusBasePriceValue')) != null,
                        }"
                    >
                        <label>{{ $t("message.instagramPlusBasePriceValue") }}</label>
                        <div v-if="site.instagramPlusBasePrice">
                            <md-input
                                v-model="site.instagramPlusBasePrice.value"
                                v-validate="!!site.instagramPlusBasePrice.value ? 'required|min:0|decimal' : null"
                                :min="0"
                                :name="$t('message.instagramPlusBasePriceValue')"
                                step="0.01"
                                type="number"
                            ></md-input>
                            <span class="md-error">{{ errors.first($t("message.instagramPlusBasePriceValue")) }}</span>
                        </div>
                        <div v-else>N/A</div>
                    </md-field>
                </b-col>

                <b-col md="4">
                    <md-field
                        :class="{
                            'md-invalid': errors.first($t('message.currency')) != null,
                        }"
                    >
                        <label>{{ $t("message.basePriceCurrency") }}</label>
                        <md-input
                            v-model="site.basePrice.currency"
                            v-validate="'required'"
                            :name="$t('message.basePriceCurrency')"
                        ></md-input>
                        <span class="md-error">{{ errors.first($t("message.basePriceCurrency")) }}</span>
                    </md-field>
                </b-col>
                <b-col md="4">
                    <md-field
                        :class="{
                            'md-invalid': errors.first($t('message.basePriceDiscount')) != null,
                        }"
                    >
                        <label>{{ $t("message.basePriceDiscount") }}</label>
                        <md-input
                            v-model="site.basePrice.discount"
                            v-validate="'required|min:0|max:100|decimal'"
                            :max="100"
                            :min="0"
                            :name="$t('message.basePriceDiscount')"
                            step="0.1"
                            type="number"
                        ></md-input>
                        <span class="md-error">{{ errors.first($t("message.basePriceDiscount")) }}</span>
                    </md-field>
                </b-col>

                <b-col v-if="!editMode" md="12">
                    <md-switch v-model="config.isRemoteDB" class="md-primary" style="height: 22px; margin: 0">
                        <span v-if="config.isRemoteDB">{{ $t("message.customerDBEnabled") }}</span>
                        <span v-else>{{ $t("message.customerDBDisabled") }}</span>
                    </md-switch>
                    <md-field
                        v-if="config.isRemoteDB"
                        :class="{
                            'md-invalid': errors.first($t('message.mongoConnectionString')) != null,
                        }"
                    >
                        <label>{{ $t("message.mongoConnectionString") }}</label>
                        <md-input
                            v-if="config.isRemoteDB"
                            v-model="site.mongoConnectionString"
                            v-validate="'required'"
                            :name="$t('message.mongoConnectionString')"
                        ></md-input>
                        <span v-if="config.isRemoteDB" class="md-error">{{
                            errors.first($t("message.mongoConnectionString"))
                        }}</span>
                    </md-field>
                </b-col>

                <b-col md="12">
                    <md-switch v-model="site.enable" class="md-primary">
                        <span v-if="site.enable">{{ $t("message.active") }}</span>
                        <span v-else>{{ $t("message.passive") }}</span>
                    </md-switch>
                </b-col>
                <b-col md="12">
                    <b-button :disabled="loading" type="submit" variant="primary">
                        <template v-if="!loading">
                            <span v-if="!editMode">{{ $t("message.save") }}</span>
                            <span v-else>{{ $t("message.update") }}</span>
                        </template>
                        <template v-else>
                            <font-awesome-icon icon="spinner" spin />
                        </template>
                    </b-button>
                    <b-button @click="closeModal">
                        <template>
                            {{ $t("message.cancel") }}
                        </template>
                    </b-button>
                </b-col>
            </b-row>
        </b-form>
    </Modal2>
</template>

<script>
import * as _ from "lodash";
import { mapActions } from "vuex";
import { log2 } from "../utils/log2";
import Modal2 from "../components/common/Modal2.vue";

const configInitialObject = {
    rootUserName: "",
    rootUserEmail: "",
    organizationName: "",
    isRemoteDB: false,
    mongoAddress: undefined,
};
const log = log2("SiteCreateModalForm");
const siteInitialObject = {
    _id: null,
    siteAddress: "",
    customerRepresentativeLimit: "",
    enable: true,
    basePrice: {
        value: 150,
        discount: 0,
        currency: "tl",
    },
    whatsappBasePrice: {
        value: 250,
        discount: 0,
        currency: "tl",
    },
    whatsappPlusBasePrice: {
        value: 1000,
        discount: 0,
        currency: "tl",
    },
    instagramBasePrice: {
        value: 350,
        discount: 0,
        currency: "tl",
    },
    instagramPlusBasePrice: {
        value: 1000,
        discount: 0,
        currency: "tl",
    },
};
export default {
    name: "SiteCreateModalForm",
    components: {
        Modal2,
    },
    props: {
        editMode: { type: Boolean, required: true },
        visible: { type: Boolean, required: true },
        onSuccess: {
            type: Function,
            default: () => {},
        },
        onCancel: {
            type: Function,
            default: () => {},
        },
        updatingSite: { type: Object },
        isModalShow: { type: Boolean },
        closeModal: { type: Function },
    },
    data() {
        return {
            config: _.cloneDeep(configInitialObject),
            loading: false,
            site: _.cloneDeep(siteInitialObject),
        };
    },
    methods: {
        ...mapActions({
            createSite: "site/createSite",
            updateSite: "site/updateSite",
        }),
        submit() {
            this.$validator.validateAll().then((response) => {
                if (response) {
                    this.loading = true;

                    const result = this.editMode
                        ? this.updateSite({
                              ...this.site,
                              rootUserName: this.config.rootUserName,
                              rootUserEmail: this.config.rootUserEmail,
                              organizationName: this.config.organizationName,
                              basePrice: {
                                  ...this.site.basePrice,
                                  discount: this.site.basePrice.discount / 100,
                              },
                          })
                        : this.createSite({
                              site: this.site,
                              config: this.config,
                          });

                    result
                        .then(() => {
                            /*this.$bvModal.hide("site-form");*/
                            this.closeModal();
                            this.$toasted.show(this.$t("message.siteSaved"), {
                                duration: 3000,
                                position: "bottom-center",
                            });
                            this.onSuccess();
                        })
                        .finally(() => (this.loading = false));
                }
            });
        },
        init(updatingSite) {
            if (this.editMode && !!updatingSite) {
                this.site = {
                    ..._.cloneDeep(updatingSite),
                    basePrice: {
                        ...updatingSite.basePrice,
                        discount: updatingSite.basePrice.discount * 100,
                    },
                };

                this.config = _.cloneDeep(configInitialObject);
                ["rootUserName", "rootUserEmail"].forEach((key) => {
                    this.config[key] = this.site[key];
                });
            } else {
                this.site = _.cloneDeep(siteInitialObject);
                this.config = _.cloneDeep(configInitialObject);
            }
        },
    },

    mounted() {
        log("Mounted updatingSite", this.updatingSite);
        this.init(this.updatingSite);
    },
    updated() {
        log("updated ", { visible: this.visible, updatingS: this.updatingSite });
    },
    watch: {
        editMode(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.init(this.updatingSite);
            }
        },
        updatingSite: {
            handler(newVal, oldVal) {
                log("updatingSite changed and editMode ", { newVal, editMode: this.editMode });
                this.init(newVal);
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss">
#site-form {
    .ant-modal {
        width: 800px !important;
    }

    .col-md-4 {
        margin-bottom: 7px;
    }
}
</style>
<style scoped></style>
